import React, { useMemo } from "react";
import { LS_E164_PER_PAGE } from "const/localStorageKeys"


import styled from "styled-components";
import TableServerSort from "components/Table/TableServerSort";


export default ({
    page,
    perPage,
    count,
    sort,
    dataList = [],
    getList,
    loading,

    getItems,

    worldzone_list = [],
    destination_list = [],
    subdestination_list = [],

    // mccMncMatchList,
    // exceptionList,
    ...props
}) => {

    const columns = useMemo(() => [
        {
            id: "code",
            dataKey: "e_code",
            align: "left",
            className: "code",
            label: "Code",
            width: 120,
            flexGrow: 1

        },
        {
            id: "worldzone",
            dataKey: "worldzone_name",
            align: "left",
            label: "Worldzone",
            className: "worldzone",
            // width: 260,
            flexGrow: 3
        },
        {
            id: "destination",
            dataKey: "destination_name",
            align: "left",
            label: "Destination",
            className: "destination",
            // width: 260,
            flexGrow: 3
        },
        {
            id: "subdestination",
            dataKey: "subdestination_name",
            align: "left",
            label: "Subdestination",
            className: "subdestination",
            // width: 260,
            flexGrow: 3
        },
        {
            id: "length_min",
            value: ({ length_min, length_max }) => `${length_min || ""}${length_min && length_max ? "-" : ""}${length_max || ""}`,
            align: "left",
            className: "length_min",
            label: "Number length",
            width: 120,
        },
    ], []);

    return (
        <>
            <StyledTable
                className={"tableFilters"}
                shouldUpdateScroll={true}
                headerHeight={46}
                // height={"75%"}
                customHeight={700}
                // maxHeight={500}
                // autoHeight
                wordWrap
                data={[...dataList]}
                {...{
                    loading
                }}
                getItems={getItems}
                columns={columns}
                originalColumns={columns}
                issort
                ispagination
                page={page}
                perPage={perPage}
                count={count}
                sort={sort}
                perPageLSKey={LS_E164_PER_PAGE}
                {...props}
            />
        </>
    );
};

const StyledTable = styled(TableServerSort)`
    && {
    
        .tableFilters__previewText {
            display: block;
            line-height: 20px;
            margin-top: 7px;
            word-break: normal;
        }
        
        .tableFilters_buttons {
            height: 20px;
            margin-top: 7px;
        }
    }
`;

// const EditFieldError = ({ text }) => (
//     <div className="rs-error-message-wrapper rs-form-control-message-wrapper rs-error-message-placement-top-end">
//         <span className="rs-error-message rs-error-message-show">
//             <span className="rs-error-message-arrow"></span>
//             <span className="rs-error-message-inner">{text}</span>
//         </span>
//     </div>
// );

// const EditField = styled(SelectPicker).attrs(props => ({
//     className: "tableFilters_field",
//     errorPlacement: "topEnd",
//     type: "text",
// }))`
// `;

// const CustomCheckbox = styled(Checkbox)`
//     &&.rs-checkbox-disabled > .rs-checkbox-checker > label {
//     color: inherit;
//     }
// `;
